import type { ReactNode } from "react";
import type { FamilyKey } from "@/utils/types/flavor";

type PillProps = {
  family: FamilyKey | string;
  // Hex (or any CSS color) override for the swatch dot. When provided this
  // wins over the static FamilyKey palette below — the catalog card uses
  // it to render colors assigned per main_category in platform.flavor_category.
  color?: string;
  children?: ReactNode;
};

const familyColor: Record<string, string> = {
  fruity: "var(--fam-fruity)",
  floral: "var(--fam-floral)",
  green: "var(--fam-green)",
  dairy: "var(--fam-dairy)",
  spicy: "var(--fam-spicy)",
  roast: "var(--fam-roast)",
  sweet: "var(--fam-sweet)",
  citrus: "var(--fam-citrus)",
};

export function Pill({ family, color: colorOverride, children }: PillProps) {
  const color = colorOverride ?? familyColor[family] ?? "var(--ink-3)";
  return (
    <span
      className="mono"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        fontSize: 10,
        color: "var(--ink-2)",
        letterSpacing: "0.08em",
        textTransform: "uppercase",
      }}
    >
      <span
        style={{
          width: 7,
          height: 7,
          borderRadius: 1,
          background: color,
          display: "inline-block",
        }}
      />
      {children || family}
    </span>
  );
}
